
/**
 * Custom component for Bimini steak items.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.2.0
 * @copyright  Copyright (C) 2023-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2023-03-23 (1.0.0) (jhoward)
 *      - <biminiFoodItem> copied to <biminiSteakItem>.
 *
 *    2023-06-21 (1.0.1) (jhoward)
 *      - Give pricing more space in <biminiSteakItem>.
 *
 *    2024-07-19 (1.0.2) (jhoward)
 *      - Rename .visual_menu--tag CSS rules to .menu--tag in <bimini-steak-item>.
 *
 *    2025-02-11 (1.1.0) (jhoward)
 *      - Add <menu-schedules> to the <biminiSteakItem> component if in admin view.
 *      - Add support for scheduling to the <biminiSteakItem> component.
 *
 *    2025-04-08 (1.2.0) (jhoward)
 *      - Remove "visual_" prefix from class names in <bimini-steak-item>.
 *      - Use <menu-item-price> in <bimini-steak-item>.
 */

import MenuTag from "../menu-tag.vue";
import {defineComponent, PropType} from "vue";
import {MenuItem} from "../defs";
import {computedIsScheduled} from "../../../helpers/menu-sections";
import MenuSchedules from "../schedule/MenuSchedules.vue";
import MenuItemPrice from "./MenuItemPrice.vue";

export default defineComponent({
  name: 'biminiSteakItem',
  components: {
    MenuItemPrice,
    MenuSchedules,
    MenuTag
  },
  props: {
    item: {
      type: Object as PropType<MenuItem>,
      required: true
    },
  },
  data() {
    return {
      titleRegex: /^\s*(\d+\s?oz)\s(.+)$/
    };
  },
  computed: {
    steakSize(): string {
      const match = this.titleRegex.exec(this.item.mi_title);
      if (match) {
        return match[1];
      }

      return '';
    },
    title(): string {
      const match = this.titleRegex.exec(this.item.mi_title);
      if (match) {
        return match[2];
      }

      return this.item.mi_title;
    },
    isScheduled: computedIsScheduled,
  }
})
